function napService($http, $q, WCConstants) {
    let vm = this;

    let categories = [{
        cat_id: 1,
        name: 'Planning Promos',
        preview_url: WCConstants.iconsCDNUrl.regular + '06-Business-Products/06-Advertising/advertising-megaphone.svg',
        documentations: [{
            doc_id: 1,
            name: 'Planning Presse',
            path: 'Guide_compliance_V5 15032022.pdf',
            picture_path: WCConstants.iconsCDNUrl.regular + '11-Content/05-Newspapers/newspaper-fold.svg',
            preview_url: WCConstants.iconsCDNUrl.regular + '11-Content/05-Newspapers/newspaper-fold.svg',
            url: WCConstants.appConfig.servers['myaccount'] + 'nap/planning/promo/press'
        }, {
            doc_id: 2,
            modules  : ['librairie'],
            name: 'Planning Librairie',
            path: 'Guide_compliance_V5 15032022.pdf',
            picture_path: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            preview_url: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            url: WCConstants.appConfig.servers['myaccount'] + 'nap/planning/promo/bookstore'
        }],
        selected: true
    }, {
        cat_id: 2,
        name: 'Meilleures Ventes librairie',
        preview_url: WCConstants.iconsCDNUrl.regular + '06-Business-Products/12-Analytics/analytics-bars.svg',
        documentations: [{
            doc_id: 1,
            name: 'Essais',
            path: 'Guide_compliance_V5 15032022.pdf',
            picture_path: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            preview_url: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            url: WCConstants.appConfig.servers['myaccount'] + 'nap/bestsellers/librairie/essais'
        }, {
            doc_id: 2,
            name: 'Poches',
            path: 'Guide_compliance_V5 15032022.pdf',
            picture_path: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            preview_url: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            url: WCConstants.appConfig.servers['myaccount'] + 'nap/bestsellers/librairie/poches'
        }, {
            doc_id: 3,
            name: 'Romans',
            path: 'Guide_compliance_V5 15032022.pdf',
            picture_path: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            preview_url: WCConstants.iconsCDNUrl.regular + '11-Content/02-Books/book-close-bookmark-1.svg',
            url: WCConstants.appConfig.servers['myaccount'] + 'nap/bestsellers/librairie/romans'
        }],
        selected: false
    }, {
        cat_id: 3,
        name: 'Flash News',
        preview_url: WCConstants.iconsCDNUrl.regular + '06-Business-Products/06-Advertising/billboard.svg',
        documentations: function () {
            return $http
                .get('myaccount://nap/flashinfos')
                .then(function (res) {
                    let count = 0;
                    let result = res.data.map(function (doc) {
                        doc.doc_id = count++;
                        doc.url = WCConstants.appConfig.servers.myaccount + 'nap/flashinfos/' + doc.name;
                        doc.picture_path = doc.preview_url = WCConstants.iconsCDNUrl.regular + '11-Content/03-Notes/notes-book.svg';
                        return doc;
                    });
                    return result;
                })
                .catch(function () {
                    return false;
                });
        },
        selected: false
    }];
    vm.fetchCategories = function () {
        return $q.when(categories);
    };

    vm.getDocumentations = function (category) {
        if(angular.isArray(category.documentations)) {
            return $q.when(category.documentations);
        }
        return category.documentations();
    };

    return vm;
}

angular.module('app.portail.nap').factory('napService', napService);
